<template>
	<div>						
		<v-row>
			<v-col>	
				<v-text-field hide-details v-model="first_name" label="Vorame" name="given_name"></v-text-field>
			</v-col>
			<v-col>	
				<v-text-field hide-details v-model="last_name" label="Nachname" name="surname"></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col>	
				<v-text-field hide-details v-model="email" label="Email" name="email"></v-text-field>
			</v-col>
		</v-row>
		<v-row v-if="organisations.length > 0">
			<v-col cols="12">	
				<v-select hide-details v-model="organisation" label="Krankenhaus" :items="organisations" item-value="id" item-text="name" multiple></v-select>
			</v-col>
		</v-row>
	</div>
</template>

<script>
	import Vuex from "vuex"
	export default {
		name: "UserForm", 
		props: {
			doc: {type: Object},
		}, 
		data: () => {
			return {
				first_name: "", 
				last_name: "", 
				email: "",
				organisation: [], 
			}
		},
		computed: {
			...Vuex.mapState({
				view: state => state.auth.view,
				organisations(state){
					//TODO - Avoid using too many of these -> i'd rather have different forms in each folder than have complicated permission based show/hide
					if( this.view == "admin" ){
						return state.organisations || []
					}
					else{
						// TODO - Ultimately a user might be managing an assessment for more than one organisation - should they  be able to select the organisation or is that determined by the group page ? TBD
						return []
					}
				} 
			}),
			displayName(){
				return `${this.first_name} ${this.last_name}`;
			}, 
			updatedDoc(){
				return {
					first_name: this.first_name, 
					last_name: this.last_name, 
					email: this.email,
					display_name: this.displayName,
					organisation: this.organisation, 
				};
			}
		}, 
		watch: {
			updatedDoc() {
				this.$emit("change", this.updatedDoc)
			}, 
			doc: {
				immediate: true, 
				handler(){					
					if( this.doc ){				
						for( var key in this.$data ){
							if( typeof this.doc[key] !== 'undefined'){
								this[key] = this.doc[key]
							}
						}
					}
				}
			}
		}
	}
</script>